import { render, staticRenderFns } from "./HerosList.vue?vue&type=template&id=2f5a9602"
import script from "./HerosList.vue?vue&type=script&lang=js"
export * from "./HerosList.vue?vue&type=script&lang=js"
import style0 from "./HerosList.vue?vue&type=style&index=0&id=2f5a9602&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports